import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { FC, useCallback } from "react";
import { ActionButton } from "../ActionButton";
import { CardContainer } from "../CardContainer";

export interface Props {
    readonly agent?: ChatUserInfo,
    readonly hasRating?: boolean;
    readonly shouldDisplay?: boolean;
    onRate?(rating: "bad" | "good" | undefined): void;
}

const ChatRating: FC<Props> = ({
    agent = {} as ChatUserInfo,
    hasRating = false,
    shouldDisplay = true,
    onRate = () => {
        // no-op
    }
}) => {

    const rateBadButtonOnClick = useCallback(() => {
        onRate("bad");
    }, [onRate]);

    const rateGoodButtonOnClick = useCallback(() => {
        onRate("good");
    }, [onRate]);

    const rateAgainButtonOnClick = useCallback(() => {
        onRate(undefined);
    }, [onRate]);

    // Do not think this prop should be here
    if (!shouldDisplay) {
        return null;
    }

    if (!hasRating) {
        return (
            <CardContainer title="Chat Rating" addClass="chat-rating-card">
                {agent.displayName} has requested you to rate the chat service.
                <div className="buttons-container">
                    <ActionButton
                        addClass="button button-rate-bad"
                        label="Rate Bad"
                        onClick={rateBadButtonOnClick}
                    />
                    <ActionButton
                        addClass="button button-rate-good"
                        label="Rate Good"
                        onClick={rateGoodButtonOnClick}
                    />
                </div>
            </CardContainer>
        );
    } else {
        return (
            <CardContainer title="Chat Rating" addClass="chat-rating-card">
                You have rated the chat service.
                <div className="buttons-container">
                    <ActionButton
                        addClass="button button-rate-again"
                        label="Rate again"
                        onClick={rateAgainButtonOnClick}
                    />
                </div>
            </CardContainer>
        );
    }
};

export default ChatRating;
